import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["alt", "src"]
const _hoisted_2 = { class: "as-rating-text" }
const _hoisted_3 = { class: "as-shirt-number-player" }
const _hoisted_4 = { class: "as-shirt-number" }
const _hoisted_5 = { class: "as-player-name as-w-o-h" }


import type { IPlayer } from "~src/interfaces";
import { formatRateColor, getPlayerNameShow } from "~src/helpers";
import SquadIncident from "~src/components/lineups/SquadIncident.vue";


const __default__ = {};

interface IProps {
  screen: string;
  isSmAll: boolean; // chỉ Hiển thị sm
  players: Array<IPlayer>;
  teamType: string;
}

interface IPlayerDefaultItem {
  x: number;
  y: number;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SquadItem',
  props: {
    screen: { default: "pc" },
    isSmAll: { type: Boolean, default: false },
    players: {},
    teamType: { default: "home" }
  },
  setup(__props: any) {

const props = __props;

const playerDefault: IPlayerDefaultItem[] = [
  { x: 50, y: 12 },  // Thủ môn
  { x: 12, y: 32 },  // Hậu vệ trái
  { x: 31, y: 32 },  // Hậu vệ trái giữa
  { x: 50, y: 32 },  // Hậu vệ giữa
  { x: 69, y: 32 },  // Hậu vệ phải giữa
  { x: 88, y: 32 },  // Hậu vệ phải
  { x: 24, y: 60 },  // Tiền vệ trái
  { x: 50, y: 60 },  // Tiền vệ giữa
  { x: 76, y: 60 },  // Tiền vệ phải
  { x: 35, y: 90 },  // Tiền đạo trái
  { x: 65, y: 90 },  // Tiền đạo phải
];

const getPlayerDefault = (index: any) => {
  return playerDefault[index];
};

const playerStyle = (x: number, y: number) => {
  if (props.screen === "sm") {
    const left = `calc(${x}% - 2.4em)`;
    const top = `calc(${y}% - 2.4em)`;

    if (props.teamType === "home") {
      return {
        left: left,
        top: top,
      };
    } else {
      return {
        right: left,
        top: top,
      };
    }
  } else {
    const left = `calc(${y}% - 2.7em)`;
    const bottom = `calc(${x}% - 2.3em)`;

    if (props.teamType === "home") {
      return {
        left: left,
        bottom: bottom,
      };
    } else {
      return {
        left: left,
        top: bottom,
      };
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (player, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["as-player-item", {
      'as-d-none as-d-md-flex': !_ctx.isSmAll && _ctx.screen === 'pc',
      'as-d-flex as-d-md-none': !_ctx.isSmAll && _ctx.screen === 'sm',
      'as-d-flex': _ctx.isSmAll,
    }]),
      style: _normalizeStyle(
      playerStyle(
        player.x || getPlayerDefault(index)?.x,
        player.y || getPlayerDefault(index)?.y
      )
    )
    }, [
      _createElementVNode("img", {
        alt: player.short_name || player.name,
        src: _ctx.getImgUrlBySport('player', player.id),
        style: {"background":"rgb(255, 255, 255)"}
      }, null, 8, _hoisted_1),
      (player.incidents.length)
        ? (_openBlock(), _createBlock(SquadIncident, {
            key: 0,
            player: player,
            types: [3, 4, 9, 15],
            classname: "as-incident-top"
          }, null, 8, ["player"]))
        : _createCommentVNode("", true),
      (player.rating && player.rating !== '0.0')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "as-rating",
            style: _normalizeStyle({ background: _unref(formatRateColor)(parseFloat(player.rating)) })
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(Number(player.rating).toFixed(1)), 1)
          ], 4))
        : _createCommentVNode("", true),
      (player.incidents.length)
        ? (_openBlock(), _createBlock(SquadIncident, {
            key: 2,
            player: player,
            types: [1, 8, 17]
          }, null, 8, ["player"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(player.shirt_number), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getPlayerNameShow)(player, true)), 1)
      ])
    ], 6))
  }), 128))
}
}

})